import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop - Scrolls main content to top on route change
 * 
 * IMPORTANT: This only scrolls the main content area (not the sidebar)
 * to preserve sidebar scroll position across navigation.
 * 
 * For authenticated pages with AppShell, the main content area has
 * className="flex-1 overflow-y-auto" and is the scrollable container.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // For authenticated pages: scroll the main content container only
    const mainContent = document.querySelector('main.overflow-y-auto');
    if (mainContent) {
      mainContent.scrollTo(0, 0);
    } else {
      // Fallback for public pages without AppShell
      // Only scroll if we're not in an authenticated layout with sidebar
      const hasSidebar = document.querySelector('[data-debug-id="sidebar-nav"]');
      if (!hasSidebar) {
        window.scrollTo(0, 0);
      }
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
